import IModule    from '../../Shared/Interfaces/IModule';
import UserDevice from '../../Shared/Util/UserDevice';

import AbrFormat    from '../Shared/Constants/AbrFormat';
import SolutionType from '../Shared/Constants/SolutionType';

/**
 * A "common" solution group covering all possible target browsers and media
 * types.
 */

class SolutionGroup {
    public static fetchSolutionModuleOfType = async (type: SolutionType): Promise<IModule> => {
        switch (type) {
            case SolutionType.HAS_PLAYER:
                return await import(/* webpackChunkName: "solution.hasplayer" */ '../HasPlayer/');
            case SolutionType.HTML5:
                return await import(/* webpackChunkName: "solution.html5" */ '../Html5/');
            case SolutionType.HTML5_FAIRPLAY:
                return await import(/* webpackChunkName: "solution.html5-fairplay" */ '../Html5Fairplay/');
            case SolutionType.SHAKA:
                return await import(/* webpackChunkName: "solution.shaka" */ '../Shaka/');
            default:
                throw new RangeError(`No solution found for type "${type}"`);
        }
    }

    public static getSolutionType = (abrFormat: AbrFormat, userDevice: UserDevice) => {
        switch (abrFormat) {
            case AbrFormat.NONE:
                return SolutionType.HTML5;
            case AbrFormat.HLS:
                return SolutionType.HTML5_FAIRPLAY;
            case AbrFormat.SMOOTHSTREAMING:
                if (userDevice.isInternetExplorer11OnOldWindows || userDevice.isOldWindows) return SolutionType.NONE;

                return SolutionType.HAS_PLAYER;
            default:
                return SolutionType.SHAKA;
        }
    }
}

export default SolutionGroup;